/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmContractSourceCodeInfo } from './EvmContractSourceCodeInfo';

export type EvmContractCodeInfo = {
    CNM: string;
    STS: EvmContractCodeInfo.STS;
    OPT: EvmContractCodeInfo.OPT;
    RUN: string;
    CV: string;
    EV: string;
    SCLIST: Array<EvmContractSourceCodeInfo>;
    ABI: string;
    CCC: string;
    DBC: string;
};

export namespace EvmContractCodeInfo {

    export enum STS {
        VERIFIED = 'VERIFIED',
    }

    export enum OPT {
        Y = 'Y',
        N = 'N',
    }


}

